import React, { FC } from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const DDUIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <path
          stroke={primary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 48L5 44 47 44 47 48zM1 53L53 53 53 48 1 48zM1 18L53 18 27 1z"
        />
        <g
          stroke={secondary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0 3L3 0 6 3" transform="translate(42 23)" />
          <path
            d="M2.792 1v11.49s0 2.87-2.792 2.87"
            transform="translate(42 23)"
          />
        </g>
        <g
          stroke={secondary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0 12L2.793 14.872 5.584 12" transform="translate(5 23)" />
          <path d="M2.793 14.36V2.873S2.793 0 0 0" transform="translate(5 23)" />
        </g>
        <g>
          <path
            stroke={secondary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M11.733 13.6h-11c-.405 0-.733-.305-.733-.68V.68C0 .305.328 0 .733 0h20.534c.404 0 .733.305.733.68v12.24s0 .68-.733.68h-.734"
            transform="translate(16 23)"
          />
          <path
            fill={secondary}
            d="M2.205 9.177c0-.375.295-.68.66-.68.366 0 .662.305.662.68 0 .376-.296.68-.661.68-.366 0-.661-.304-.661-.68M4.849 9.177c0-.375.295-.68.66-.68.366 0 .662.305.662.68 0 .376-.296.68-.661.68-.366 0-.661-.304-.661-.68"
            transform="translate(16 23)"
          />
          <path
            stroke={secondary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M16.322 13.08c-.73 0-1.322-.61-1.322-1.36 0-.75.592-1.36 1.322-1.36.73 0 1.322.61 1.322 1.36M16.322 13.08c.73 0 1.322.61 1.322 1.36 0 .75-.592 1.36-1.322 1.36-.73 0-1.322-.61-1.322-1.36M0 3L22 3M0 6L22 6M16.322 10.36L16.322 9M16.322 17.16L16.322 15.8"
            transform="translate(16 23)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default DDUIcon;
